import React, { useEffect, useState } from 'react'
import { Button, Modal, Form, Toast } from '@themesberg/react-bootstrap'

export default function WhitelistIpFormModal({ show, mode, item, currentIp, onHide, onSubmit }) {
  const isEdit = mode === 'edit'

  const [ip, setIp] = useState('')
  const [description, setDescription] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (!show) return
    setError('')
    if (isEdit && item) {
      setIp(item.ip || '')
      setDescription(item.description || '')
    } else {
      setIp(currentIp || '')
      setDescription('')
    }
  }, [show, isEdit, item, currentIp])

  const handleSubmit = async () => {
    setError('')
    const trimmedIp = ip.trim()
    if (!trimmedIp) {
      setError('IP là bắt buộc')
      return
    }

    let payload
    if (!isEdit) {
      payload = { ip: trimmedIp, description: description.trim() || null }
    } else {
      payload = {
        ip: item.ip,
        newIp: trimmedIp,
        description: description.trim() || null,
      }
    }

    const result = await onSubmit(payload)
    if (result?.error) {
      setError(result.message || 'Có lỗi xảy ra')
      return
    }
    onHide(true)
  }

  return (
    <Modal show={show} onHide={() => onHide(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? 'Sửa IP whitelist' : 'Thêm IP whitelist'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Toast show className="d-block mb-3" bg="danger">
            <Toast.Body className="text-white">{error}</Toast.Body>
          </Toast>
        )}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>IP</Form.Label>
            <Form.Control
              type="text"
              value={ip}
              onChange={(e) => setIp(e.target.value)}
              placeholder="vd: 203.0.113.10"
              required
            />
            {!isEdit && currentIp ? (
              <Form.Text className="text-muted">
                Public IP hiện tại: <code>{currentIp}</code>
                {' '}
                <Button variant="link" size="sm" className="p-0 align-baseline" onClick={() => setIp(currentIp)}>
                  Dùng IP này
                </Button>
              </Form.Text>
            ) : null}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Mô tả</Form.Label>
            <Form.Control
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="vd: Văn phòng HN"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onHide(false)}>
          Đóng
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {isEdit ? 'Lưu' : 'Thêm'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
